import React from "react";
import { useParams } from "react-router-dom";
import BookingForm from "../components/BookingForm";
import { Plane, Clock, Banknote, ShieldCheck } from "lucide-react";

const AIRPORT_BG = "https://images.pexels.com/photos/15273870/pexels-photo-15273870.jpeg";

const AIRPORTS = {
  schiphol: { code: "SCH", name: "Schiphol Airport", city: "Amsterdam", iata: "AMS", desc: "Premium airport transfers to/from Amsterdam Schiphol. Flight tracking, meet-and-greet, fixed prices." },
  eindhoven: { code: "EIN", name: "Eindhoven Airport", city: "Eindhoven", iata: "EIN", desc: "Fast and reliable transfers to Eindhoven Airport with a uniformed chauffeur." },
  rotterdam: { code: "RTM", name: "Rotterdam The Hague Airport", city: "Rotterdam", iata: "RTM", desc: "Door-to-terminal service for business and leisure travellers." },
  brussels: { code: "BRU", name: "Brussels Airport", city: "Brussels", iata: "BRU", desc: "Cross-border transfers to Brussels — fixed Dutch quality, all-inclusive pricing." },
  dusseldorf: { code: "DUS", name: "Düsseldorf Airport", city: "Düsseldorf", iata: "DUS", desc: "Comfortable cross-border rides to Düsseldorf Airport in premium sedans." },
};

export default function Airport() {
  const { slug } = useParams();
  const a = AIRPORTS[slug] || AIRPORTS.schiphol;

  return (
    <div className="text-white">
      <section className="relative hero-overlay" style={{ minHeight: "60vh" }}>
        <img src={AIRPORT_BG} alt={a.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 pt-20 pb-12">
          <div className="text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-3">{a.iata} · {a.city}</div>
          <h1 className="font-heading text-5xl lg:text-7xl">
            <span className="text-gold-gradient italic">{a.name}</span> Transfers
          </h1>
          <p className="mt-5 max-w-2xl text-white/75 text-lg">{a.desc}</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid lg:grid-cols-2 gap-10">
        <div className="space-y-5">
          {[
            [Banknote, "Fixed price", "All-inclusive — no surge, no surprises."],
            [Clock, "Flight tracking", "We track your flight and adjust pickup time automatically."],
            [ShieldCheck, "Meet & greet", "Uniformed chauffeur with name sign at arrivals."],
            [Plane, "Luggage friendly", "Premium sedans with generous luggage space."],
          ].map(([Icon, title, body], i) => (
            <div key={i} data-testid={`airport-feature-${i}`} className="flex gap-4 rounded-xl border border-white/10 bg-[#0A1128] p-6">
              <div className="w-12 h-12 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center shrink-0">
                <Icon className="w-6 h-6 text-[#D4AF37]" />
              </div>
              <div>
                <div className="font-heading text-xl mb-1">{title}</div>
                <p className="text-white/65 text-sm">{body}</p>
              </div>
            </div>
          ))}
        </div>
        <div>
          <BookingForm defaultAirport={a.code} />
        </div>
      </section>
    </div>
  );
}
